import { PlanButton } from "@molecules/PlanButton";
import { updatePlanButton } from "./functions/updatePlanButton";
import type { TPlanContainerHeader } from "./types";
import { plansButtons } from "./variables";

export const PlanContainerHeader = ({
  onClickChangePlan,
}: TPlanContainerHeader) => {
  const PlanContainerHeaderElement = document.createElement("div");
  PlanContainerHeaderElement.className =
    "w-full grid flex-col lg:grid-cols-2 border-b border-gray-100";

  plansButtons.forEach((buttonProps, indexProps) => {
    const handleClickPlanButton = (event: MouseEvent) => {
      const target = event.currentTarget as HTMLButtonElement;
      updatePlanButton({ target, action: "active" });

      PlanContainerHeaderElement.querySelectorAll("button").forEach(
        (element) => {
          if (element !== target)
            updatePlanButton({
              target: element,
              action: "inactive",
            });
        },
      );

      onClickChangePlan(buttonProps.id);
    };

    PlanContainerHeaderElement.appendChild(
      PlanButton({
        ...buttonProps,
        active: indexProps === 0,
        onClick: handleClickPlanButton,
      }),
    );
  });

  return PlanContainerHeaderElement;
};
